import { useState } from "react";
import { PaywallContext } from "../hooks/usePaywall";

export const PaywallProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  return <PaywallContext.Provider value={{ isOpen, setIsOpen }}>{children}</PaywallContext.Provider>;
};
